// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { OrderCustomerDTO } from '../models';
import { PaymentMethodChecksRequestDTO } from '../models';
import { PaymentMethodChecksResponseDTO } from '../models';
import { TenancyUserDTO } from '../models';
/**
 * OrderCustomersApi - axios parameter creator
 * @export
 */
export const OrderCustomersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get Order Customer By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCustomerById(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getOrderCustomerById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getOrderCustomerById.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Get TenancyUser By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyUserById(orderId: string, customerId: string, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling getTenancyUserById.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling getTenancyUserById.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/tenancy-user`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Check if the payment method is valid for the payment type
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCardChecks(orderId: string, customerId: string, paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO, options: any = {}): RequestArgs {
            // verify required parameter 'orderId' is not null or undefined
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId','Required parameter orderId was null or undefined when calling paymentCardChecks.');
            }
            // verify required parameter 'customerId' is not null or undefined
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId','Required parameter customerId was null or undefined when calling paymentCardChecks.');
            }
            // verify required parameter 'paymentMethodChecksRequestDTO' is not null or undefined
            if (paymentMethodChecksRequestDTO === null || paymentMethodChecksRequestDTO === undefined) {
                throw new RequiredError('paymentMethodChecksRequestDTO','Required parameter paymentMethodChecksRequestDTO was null or undefined when calling paymentCardChecks.');
            }
            const localVarPath = `/v2/orders/{orderId}/customers/{customerId}/payment-card-checks`
                .replace(`{${"orderId"}}`, encodeURIComponent(String(orderId)))
                .replace(`{${"customerId"}}`, encodeURIComponent(String(customerId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"PaymentMethodChecksRequestDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(paymentMethodChecksRequestDTO !== undefined ? paymentMethodChecksRequestDTO : {}) : (paymentMethodChecksRequestDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrderCustomersApi - functional programming interface
 * @export
 */
export const OrderCustomersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get Order Customer By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCustomerById(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrderCustomerDTO> {
            const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).getOrderCustomerById(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Get TenancyUser By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyUserById(orderId: string, customerId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenancyUserDTO> {
            const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).getTenancyUserById(orderId, customerId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Check if the payment method is valid for the payment type
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCardChecks(orderId: string, customerId: string, paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<PaymentMethodChecksResponseDTO> {
            const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).paymentCardChecks(orderId, customerId, paymentMethodChecksRequestDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrderCustomersApi - factory interface
 * @export
 */
export const OrderCustomersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get Order Customer By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrderCustomerById(orderId: string, customerId: string, options?: any) {
            return OrderCustomersApiFp(configuration).getOrderCustomerById(orderId, customerId, options)(axios, basePath);
        },
        /**
         * Get TenancyUser By OrderId and CustomerId
         * @param {string} orderId Order id 
         * @param {string} customerId Customer id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyUserById(orderId: string, customerId: string, options?: any) {
            return OrderCustomersApiFp(configuration).getTenancyUserById(orderId, customerId, options)(axios, basePath);
        },
        /**
         * Check if the payment method is valid for the payment type
         * @param {string} orderId OrderId
         * @param {string} customerId CustomerId
         * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paymentCardChecks(orderId: string, customerId: string, paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO, options?: any) {
            return OrderCustomersApiFp(configuration).paymentCardChecks(orderId, customerId, paymentMethodChecksRequestDTO, options)(axios, basePath);
        },
    };
};

/**
 * OrderCustomersApi - interface
 * @export
 * @interface OrderCustomersApi
 */
export interface OrderCustomersApiInterface {
    /**
     * Get Order Customer By OrderId and CustomerId
     * @param {string} orderId Order id 
     * @param {string} customerId Customer id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApiInterface
     */
    getOrderCustomerById(orderId: string, customerId: string, options?: any): AxiosPromise<OrderCustomerDTO>;

    /**
     * Get TenancyUser By OrderId and CustomerId
     * @param {string} orderId Order id 
     * @param {string} customerId Customer id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApiInterface
     */
    getTenancyUserById(orderId: string, customerId: string, options?: any): AxiosPromise<TenancyUserDTO>;

    /**
     * Check if the payment method is valid for the payment type
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApiInterface
     */
    paymentCardChecks(orderId: string, customerId: string, paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO, options?: any): AxiosPromise<PaymentMethodChecksResponseDTO>;

}

/**
 * OrderCustomersApi - object-oriented interface
 * @export
 * @class OrderCustomersApi
 * @extends {BaseAPI}
 */
export class OrderCustomersApi extends BaseAPI implements OrderCustomersApiInterface {
    /**
     * Get Order Customer By OrderId and CustomerId
     * @param {string} orderId Order id 
     * @param {string} customerId Customer id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApi
     */
    public getOrderCustomerById(orderId: string, customerId: string, options?: any) {
        return OrderCustomersApiFp(this.configuration).getOrderCustomerById(orderId, customerId, options)(this.axios, this.basePath);
    }

    /**
     * Get TenancyUser By OrderId and CustomerId
     * @param {string} orderId Order id 
     * @param {string} customerId Customer id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApi
     */
    public getTenancyUserById(orderId: string, customerId: string, options?: any) {
        return OrderCustomersApiFp(this.configuration).getTenancyUserById(orderId, customerId, options)(this.axios, this.basePath);
    }

    /**
     * Check if the payment method is valid for the payment type
     * @param {string} orderId OrderId
     * @param {string} customerId CustomerId
     * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrderCustomersApi
     */
    public paymentCardChecks(orderId: string, customerId: string, paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO, options?: any) {
        return OrderCustomersApiFp(this.configuration).paymentCardChecks(orderId, customerId, paymentMethodChecksRequestDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrderCustomersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get Order Customer By OrderId and CustomerId
 * @param {string} orderId Order id 
 * @param {string} customerId Customer id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getOrderCustomerById(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrderCustomerDTO> {
    const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).getOrderCustomerById(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Get TenancyUser By OrderId and CustomerId
 * @param {string} orderId Order id 
 * @param {string} customerId Customer id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyUserById(
    orderId: string,
    customerId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenancyUserDTO> {
    const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).getTenancyUserById(orderId, customerId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Check if the payment method is valid for the payment type
 * @param {string} orderId OrderId
 * @param {string} customerId CustomerId
 * @param {PaymentMethodChecksRequestDTO} paymentMethodChecksRequestDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function paymentCardChecks(
    orderId: string,
    customerId: string,
    paymentMethodChecksRequestDTO: PaymentMethodChecksRequestDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<PaymentMethodChecksResponseDTO> {
    const localVarAxiosArgs = OrderCustomersApiAxiosParamCreator(configuration).paymentCardChecks(orderId, customerId, paymentMethodChecksRequestDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

